<script setup></script>

<template>
    <h3 class="uppercase font-bold">
        <slot />
    </h3>
</template>
